import React, { useState, useEffect } from 'react';
import { Upload, message, Button } from 'antd';
import { API, axiosAuthInstance, axiosEmptyInstance } from '../../../api';

// import imageOnError from 'utils/imageOnError';
// import Previewicon from '../NavIcons/previewIcon';

type Props = {
  setUrl: Function,
  endPoint: string,
  url: string,
  name: string,
  accept: string,
  type: string,
  keyType: string,
  publicKeyUrl: String,
}

const FileUploader = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [url, setImageURL] = useState(props.url);
  const [preview, setPreview] = useState();
  const [fileName, setFileName] = useState('');
  const { accept, type, keyType, publicKeyUrl } = props;

  useEffect(() => {
    props.setUrl && props.setUrl(url);
  }, [url]);

  useEffect(() => {
    if (props.url) {
      setPreview(<img
        src={`${props.url}?ts=${new Date().getTime()}`}
        // onError={event => imageOnError(event)}
        alt=""
        title={props.name}
        style={{ width: '100%' }}
      />);
    }
  }, []);

  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    const PDF = 'application/pdf';
    const IMAGE = 'image/*';
    const pattern = file.type.match(IMAGE) || file.type.match(PDF);
    if (!pattern) {
      message.error('Only image or pdf');
      return false;
    }
    if (pattern && !isLt5M) {
      message.error('File must smaller than 5MB!');
      return false;
    }
    return true;
  };

  const fileReader = async file => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsArrayBuffer(file);
  });

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = async info => {
    setFileName(info.file.name);
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    try {
      setImageURL('');
      setLoading(true);
      const file = info.file.originFileObj;
      if (file) {
        const { data: { entity } } = await API.get(props.endPoint, {
          headers: {
            'x-api-key': publicKeyUrl,
          },
        });
        await axiosEmptyInstance.put(entity, await fileReader(file), { headers: { 'Content-Type': file.type } });
        // eslint-disable-next-line max-len
        const { data: { entity: { fileUrl } } } = await API.post(
          props.endPoint,
          keyType ? { fileUrl: entity, keyType } : { fileUrl: entity },
          {
            headers: {
              'x-api-key': publicKeyUrl,
            },
          }
        );
        const pattern = /image*/;
        if (file.type.match(pattern)) {
          getBase64(file, imageUrl => {
            setPreview(<img src={imageUrl} alt={props.name} title={props.name} style={{ width: '100%' }} />);
          });
          // onError={event => imageOnError(event)}
          setFileName('');
        } else {
          // setPreview(<Previewicon />);
          if (type) {
            setFileName(info.file.name);
          }
        }
        setImageURL(fileUrl);
      }
    } catch (error) {
      setImageURL(props.url);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Upload
      accept={accept || ''}
      showUploadList={false}
      beforeUpload={beforeUpload}
      onChange={handleChange}
    >
      <Button icon={loading ? "loading" : "upload"} type="primary">Upload</Button>
      {
        fileName && (
          <span>
            <br />{fileName}
          </span>
        )
      }
    </Upload>
  );
};

export default FileUploader;
